import logo from './Assets/GFX/logo.svg';
import './Styles/App.scss';
import React, { Component, useEffect } from 'react';

class App extends Component {

  constructor() {
    super();
    this.colors = ["lilac", "green", "pink", "yellow"];
    this.topics = ["webseiten", "onlineshops", "apps", "animationen"];
    this.currentTopicIndex = 0;
    this.interval = "";
    this.state = {
      cC : "pink",
      cT : "webseiten"
    }
  }
  
  componentDidMount = () => {
    console.log("trigger once")
    this.topicSwitchTimer();
  }

  topicSwitchTimer = () => {
    if (this.interval > 0) return;
    this.interval = setInterval(()=> {
      this.currentTopicIndex += 1;
      if (this.currentTopicIndex === this.topics.length) {
        this.currentTopicIndex = 0;
      }
      this.switchTopic(this.topics[this.currentTopicIndex]);
    }, 2000);
  }

  switchTopic(topic) {

    switch (topic) {
      
      case ("onlineshops") : 
        this.setState({cC: "lilac"});    
        this.setState({cT: "onlineshops"});    
        break;
     
      case ("apps") : 
        this.setState({cC: "green"});    
        this.setState({cT: "apps"});    
        break;
     
      case ("webseiten") : 
        this.setState({cC: "pink"});    
        this.setState({cT: "webseiten"});    
        break;

      case ("animationen") : 
        this.setState({cC: "yellow"});    
        this.setState({cT: "animationen"});    
        break;

      default : 
        console.log("nottin");
    }
  }
  
  render() {

    const { cC, cT } = this.state;

    return (
      <div className="App">
        <header>
          <img src={logo} className="logo" alt="logo" />
          <h1 className="name-heading">marcel_sydow</h1>
          <h2 className="sub-heading">Ihr Partner für Ihren professionellen Internetauftritt</h2>
          <h3 className="construction-heading">Webseite im Umbau, aber dennoch für Sie da!</h3>
          <a href="mailto:info@marcelsydow.de" className="button">schreiben Sie mir eine Mail</a>
          <p className="contact-text">Ich freue mich auf Ihre Anfrage.</p>
          <div className={`header-shape-triangle ${cC}`}></div>
        </header>
        <footer>
          <div className={`footer-shapes ${cC}`}>
            <div className={`edges edge-top ${cC}`}></div>
            <div className={`edges edge-bottom ${cC}`}></div>
            <div className="trapezoid">
          </div>
          </div>
          <div className="topic-switcher">
            <h2 className={`topic ${cT === "webseiten" ? "is-current" : ""} ${cT === "onlineshops" ? "is-last" : ""}`}>Webseiten</h2>
            <h2 className={`topic ${cT === "onlineshops" ? "is-current" : ""}${cT === "apps" ? "is-last" : ""}`}>Onlineshops</h2>
            <h2 className={`topic ${cT === "apps" ? "is-current" : ""}${cT === "animationen" ? "is-last" : ""}`}>Apps</h2>
            <h2 className={`topic ${cT === "animationen" ? "is-current" : ""}${cT === "webseiten" ? "is-last" : ""}`}>2D-Animationen</h2>
          </div>
        </footer>
      </div>
    );

  }
}

export default App;
